// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum MoveTypeId {
  None = 0,
  Foot = 1,
  Boot = 2,
  Tires = 40,
  Treads = 41,
  Helicopter = 62
}
